import { createContext, useContext, useEffect, useState } from "react";
import { ProfileResponseData } from "../../core/models/Profile";
import NetworkingServiceError from "../../core/services/network/NetworkServiceError";
import appConfig from "../../util/appConfig";

// This context allows the app to get the users profiles information

export type ProfileError = NetworkingServiceError;

// Create type
export type ProfilesDataType = {
  profilesResponseData?: ProfileResponseData;
  setProfilesResponseData: (responseData?: ProfileResponseData) => void;
  profilesLoading: boolean;
  setProfilesLoading: (isLoading: boolean) => void;
  profilesError: ProfileError | undefined;
  setProfilesError: (error?: ProfileError) => void;
};

// Create context for type
// @ts-ignore
export const ProfileDataContext = createContext<ProfilesDataType>();

//Create provider of the context
export const ProfilesDataProvider = ({ children }: any) => {
  const [profilesResponseData, setProfilesResponseData] =
    useState<ProfileResponseData>();
  const [profilesLoading, setProfilesLoading] = useState<boolean>(false);
  const [profilesError, setProfilesError] = useState<ProfileError>();

  const value = {
    profilesResponseData,
    setProfilesResponseData,
    profilesLoading,
    setProfilesLoading,
    profilesError,
    setProfilesError,
  };

  useEffect(() => {
    /* istanbul ignore next: logs */
    if (appConfig.debugProfile && profilesResponseData)
      console.debug("[Profiles][profilesResponseData] ", profilesResponseData);
  }, [profilesResponseData]);

  useEffect(() => {
    /* istanbul ignore next: logs */
    if (appConfig.debugProfile && profilesLoading)
      console.debug("[Profiles][profilesLoading] ", profilesLoading);
  }, [profilesLoading]);

  useEffect(() => {
    /* istanbul ignore next: logs */
    if (appConfig.debugProfile && profilesError)
      console.warn(
        "[Profiles][Error] ",
        profilesError?.userMessage(),
        profilesError?.debugMessage()
      );
  }, [profilesError]);
  return (
    <ProfileDataContext.Provider value={value}>
      {children}
    </ProfileDataContext.Provider>
  );
};

export const useProfilesContext = () => useContext(ProfileDataContext);
